class FetchAccountMetrics {
	constructor(public readonly accountId: number) {
		Object.freeze(this);
	}
}

export default FetchAccountMetrics;
